import { render, staticRenderFns } from "./ImagesSideBySideModal.vue?vue&type=template&id=cff8c1a6&"
import script from "./ImagesSideBySideModal.vue?vue&type=script&lang=js&"
export * from "./ImagesSideBySideModal.vue?vue&type=script&lang=js&"
import style0 from "./ImagesSideBySideModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports